import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSettingsState } from '../store/settings.slice';

interface FontProviderProps {
  children: React.ReactNode;
}

const FontProvider: React.FC<FontProviderProps> = ({ children }) => {
  const { fontFamily } = useSelector(getSettingsState);

  useEffect(() => {
    if (fontFamily) {
      // Apply font family to the entire app more comprehensively
      document.documentElement.style.fontFamily = fontFamily;
      document.body.style.fontFamily = fontFamily;
      
      // Also apply to all elements that might have specific font styling
      const allElements = document.querySelectorAll('*');
      allElements.forEach((element) => {
        const computedStyle = window.getComputedStyle(element);
        // Only override if the element doesn't have a specific font-family set
        if (computedStyle.fontFamily === 'inherit' || 
            computedStyle.fontFamily.includes('system-ui') ||
            computedStyle.fontFamily.includes('sans-serif') ||
            computedStyle.fontFamily.includes('serif')) {
          (element as HTMLElement).style.fontFamily = fontFamily;
        }
      });
      
      // Add a CSS rule to ensure all future elements inherit the font
      const styleId = 'jadwalla-font-override';
      const existingStyle = document.getElementById(styleId);
      if (existingStyle) {
        existingStyle.remove();
      }
      
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        * {
          font-family: ${fontFamily} !important;
        }
        input, textarea, select, button {
          font-family: ${fontFamily} !important;
        }
        .mantine-* {
          font-family: ${fontFamily} !important;
        }
        [class*="mantine-"] {
          font-family: ${fontFamily} !important;
        }
      `;
      document.head.appendChild(style);

    }
  }, [fontFamily]);

  return <>{children}</>;
};

export default FontProvider;
